import { call, put } from 'redux-saga/effects'
import { fetchApi } from '../helpers/fetchApi'

import {
  fetchSimilarItemsSuccess,
  fetchSimilarItemsFailure
} from '../../actionCreators/similarItems/similarItemsActionCreators'
import {
  fetchShopTheLookSuccess,
  fetchShopTheLookFailure
} from '../../actionCreators/shopTheLook/shopTheLookActionCreators'

import featureBrandConfigs from '../../providers/BrandConfigContext/config/featureBrandConfigs'

const syteEndpoint = 'https://cdn.syteapi.com/v1.1/similars'

const configData = {
  similarItems: {
    successAction: fetchSimilarItemsSuccess,
    failureAction: fetchSimilarItemsFailure
  },
  shopTheLook: {
    successAction: fetchShopTheLookSuccess,
    failureAction: fetchShopTheLookFailure
  }
}

const queryParams = {
  fields: 'sku',
  features: {
    similarItems: 'similars',
    shopTheLook: 'ctl'
  },
  syteProduct: {
    similarItems: 'similars',
    shopTheLook: 'ctl'
  }
}

function* syteRecsSaga(action) {
  const BRAND = process.env.BRAND || 'ARGOS'
  const brandConfig = featureBrandConfigs[BRAND.toLocaleLowerCase()]
  const {
    SYTE: { SYTE_ACCOUNT_ID, SYTE_SIGNATURE }
  } = brandConfig

  const { partNumber, type, productImage } = action.payload
  const { features, fields, syteProduct } = queryParams
  const { [type]: relevantData } = configData
  const { successAction: success, failureAction: failure } = relevantData
  try {
    // call syte rec api get recommended skus
    const syteRequest = `${syteEndpoint}?q=sku:${partNumber}&account_id=${SYTE_ACCOUNT_ID}&sig=${SYTE_SIGNATURE}&fields=${fields}&features=${features[type]}&syte_product=${syteProduct[type]}&imageUrl=${productImage}`
    const { response: syteResponse } = yield call(fetchApi, syteRequest)
    const successAction = success({ syteResponse, partNumber, type })
    yield put(successAction)
  } catch (error) {
    const failureAction = failure({ errorDetail: error.message, partNumber })
    yield put(failureAction)
  }
}

export { syteRecsSaga, syteEndpoint }
